<div mdbModal #remainderModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="remainderModalLabel" aria-hidden="true"
    [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}" style="z-index: 999 !important;"
    style="z-index: 999 !important;">
    <div class="modal-dialog modal-md" role="document">

        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <div class="row text-left">

                <!--Grid column-->
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">

                        <div class="col-md-12 rmDetailsSectionPopup">
                            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                            <p class="m-0 p-0" style="text-align: center;font-weight: bold;" *ngIf="typeOfDisplay!='matchFollowUp'">
                                Update Remainder for {{profileId}}<br>
                            </p>
                            <p class="m-0 p-0" style="text-align: center;font-weight: bold;" *ngIf="typeOfDisplay==='matchFollowUp'">
                                Remainder for {{profileId}}<br>
                            </p>
                        </div>

                    </div>

                </div>
                <div class="col-md-12">
                    <form class="text-center pt-2 text-left" [formGroup]="remainderForm">
                        <div class="col-md-6 inputBox">
                            <label class="text-left ka-float-left ka-custom-margin-lable-bottom" for="">
                                Date Of Remainder <span class="ka-em-requried">*</span>
                            </label>
                            <input matInput [matDatepicker]="remainderDate" (keypress)="onKeypressEvent($event)"
                                class="form-control" formControlName="remainderDate"
                                placeholder="DD/MM/YYYY" [min]="minDate"
                                >
                            <mat-datepicker-toggle matSuffix [for]="remainderDate"></mat-datepicker-toggle>
                            <mat-datepicker #remainderDate></mat-datepicker>

                            <div *ngIf="remainderForm['value']['remainderDate']==='' && !remainderForm.valid && remainderFormSubmmited === true" class="error-msg1">
                                Select Date Of Remainder
                            </div>
                            <!-- <div class="error-msg1" *ngIf="remainderForm.get('remainderDate').hasError('dateInvalid')">
                                Please enter date in "DD/MM/YYYY" format
                            </div> -->

                        </div>
                        <!-- <input type="date" name="" id="" formControlName="remainderDate"> -->
                        <div class="col-md-6"></div>
                        <div class="row mt-3" *ngIf="typeOfDisplay!='matchFollowUp'">
                            <div class="col-md-6" style="left: 18px;">
                                <label class="text-left ka-float-left " for="defaultContactFormName">
                                    Time Of Remainder <span class="ka-em-requried">*</span></label>
                                <select #hoursSelect class="browser-default custom-select" 
                                    formControlName="hours" >
                                    <option ngValue="">Select Hours</option>
                                    <option *ngFor="let hour of hoursArray" [ngValue]="hour['value']">
                                        <p>{{hour['label']}}</p>
                                    </option>
                                </select>
                                <div *ngIf="remainderForm['value']['hours']==='' && !remainderForm.valid && remainderFormSubmmited === true" class="error-msg1">
                                    Hours are required.</div>
                            </div>
                            <div class="col-md-6 mt-3" style="left: -11px; top: 7px;">
                                <label class="text-left ka-float-left " for="defaultContactFormName">
                                </label>
                                <select #minuteSelect class="browser-default custom-select" 
                                    formControlName="minutes" >
                                    <option ngValue="">Select Minutes</option>
                                    <option *ngFor="let minute of minutesArray" [ngValue]="minute['value']">
                                        <p>{{minute['label']}}</p>
                                    </option>
                                </select>
                                <div *ngIf="remainderForm['value']['minutes']==='' && !remainderForm.valid && remainderFormSubmmited === true" class="error-msg1">
                                    Minutes are required.</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="left: 18px;">
                                <button mdbBtn
                                    class="ka-white-button tButton ka-btn-primary btn-success btn ka-custom-button-login"
                                    mdbWavesEffect type="submit" 
                                    (click)="submitRemainderForm()"  *ngIf="typeOfDisplay!='matchFollowUp'">Submit</button>

                                    <button mdbBtn
                                    class="ka-white-button tButton ka-btn-primary btn-success btn ka-custom-button-login"
                                    mdbWavesEffect type="submit" 
                                    (click)="submitRemainderFormForMatchFollowUp()"  *ngIf="typeOfDisplay==='matchFollowUp'">Submit</button>
                            </div>
                            <div class="col">
                                <p style="padding-top: 27%;cursor: pointer;"> <span (click)="closeModal()">Cancel</span>
                                </p>
                            </div>
                        </div>


                    </form>
                </div>


            </div>
        </div>
    </div>

</div>

<div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
aria-hidden="true"   [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
<div class="modal-dialog modal-md modal-dialog-centered" role="document">

  <div class="modal-content">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="successModal.hide()">
      <span aria-hidden="true" class="">&times;</span>
    </button>
    <div class="row text-left">

      <!--Grid column-->
      <div class="col-md-12 rmSectionPopup">
        <div class="row p-2 m-2">

          <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
            <p class="mt-2 p-0">{{responseMessage}} </p>

            <div class="action-buttons">
              <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                mdbWavesEffect type="submit" (click)="successModal.hide()">ok
              </button>



            </div>

          </div>
        </div>

      </div>

      <!--Grid column-->



    </div>
  </div>
</div>
</div>